export const REDIRECT_MS = 5000;
export const SUGGEST_INTERVAL_MS = 500;
export const RELOAD_MATTER_STATUS_INTERVAL_MS = 5000;
